import TecnologiasGrid from "./TecnologiasGrid";
import useIntersectionObserver from "./Intersection";
import { useEffect } from "react";

const Section = ({ children, className = "" }) => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section ref={ref} className={`${className} ${isVisible ? "show" : ""}`}>
      {children}
    </section>
  );
};


export default function CompInicio({ setPagina }) {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const stack = [
    "CSS3",
    "PHP",
    "HTML5",
    "Java",
    "JavaScript",
    "JQuery",
    "NodeJS",
    "Laravel",
    "Blade",
    "React",
    "Blazor",
    "C#",
    "PhpMyAdmin",
    "MySQL",
    "SQL Server",
    "Linux",
    "Ubuntu",
    "Android",
    "Wordpress"
  ];

  const herramientas = [
    "Figma",
    "Photoshop",
    "Premiere"
  ];

  const ai = [
    "Prompt Writing"
  ];


  return (
    <div className="content inicio">
      <Section className="section presentacion full-height">
        <div className="titulo-inicio">
          <div className="frase glowing-border">
            <h3><span className="palabra">¡Bienvenido!</span><br />
              <span className="palabra">¿Necesitas&nbsp;</span><span className="palabra">un&nbsp;</span><span className="palabra">desarrollador&nbsp;</span><span className="palabra">Web?&nbsp;</span></h3>
          </div>

        </div>

        <div className="box-data necesitas">
          <h1>Hablemos de tu proyecto</h1>
          <p>Mi nombre es Sergio Salgado. Ofrezco soluciones personalizadas tanto para empresas que quieren lanzar su propia web como para equipos que buscan colaboración técnica en proyectos digitales. Ya sea diseñando y desarrollando sitios desde cero, o integrándome como parte de tu equipo para aportar experiencia en frontend, backend o full stack, estoy aquí para ayudarte.</p>
        </div>

      </Section>

      <Section className="section acerca">
        <div className="box-data acerca">
          <h1>Acerca de mí</h1>
          <p>Mi viaje en la programación comenzó en 2019 de manera autodidacta, desarrollando proyectos cada vez más complejos a lo largo de <strong>6 años</strong>.</p>
          <p>Durante este tiempo, he explorado diversas tecnologías y perfeccionado mis habilidades impulsado por mi pasión por la programación y el desarrollo. Este interés me llevó a profesionalizarme en el sector, culminando mis estudios en Desarrollo Web en 2025.</p>
          <p>Destacando en programación y gestión de bases de datos, he desarrollado una sólida capacidad para resolver problemas y comprender conceptos técnicos complejos.</p>
          <p>Mi trayectoria en desarrollo web, iniciado con PHP y JavaScript puro, concluye con el dominio de frameworks modernos como <strong>Laravel y React</strong>. Me especializo en combinar creatividad y lógica para diseñar soluciones eficientes e innovadoras.</p>
          <p><strong>Siempre estoy en búsqueda de nuevos desafíos y oportunidades para seguir creciendo profesionalmente.</strong></p>
        </div>

      </Section>

      <Section className="section trabajos">
        <div className="box-data">
          <h1>Mi experiencia en desarrollo</h1>

          <button className="button-big" onClick={() => setPagina("trabajos")}>Mis proyectos</button>
        </div>

      </Section>

      <Section className="section tecnologias">
        <div className="box-data">
          <h1>Stack Tecnológico</h1>
          <p><strong>Lenguajes:</strong> Java, PHP, JavaScript, HTML5, CSS3</p>
          <p><strong>Frameworks y Librerías:</strong> Laravel, React, Wordpress, jQuery, Google Maps API</p>
          <p><strong>Entornos de desarrollo:</strong> Visual Studio, Eclipse, Android Studio</p>
          <p><strong>Bases de Datos:</strong> MySQL (phpMyAdmin), SQLite, Firebase</p>
          <p><strong>Backend:</strong> Laravel (Eloquent ORM, Middleware, Controladores, Autenticación, API REST, Laravel Passport/Sanctum), Node.js (básico)</p>
          <p><strong>Frontend:</strong> React (Componentes, Estado, Hooks, Router), Blade (Laravel), JavaScript (vanilla), CSS con Tailwind y Bootstrap</p>
          <p><strong>APIs y Servicios:</strong> Google Maps API, Firebase Firestore/Realtime Database, RESTful APIs, Retrofit, Volley</p>
          <p><strong>Herramientas y Tecnologías:</strong> Git, GitHub, Docker (básico), Postman, Glide (Android), Prompt Engineering</p>
          <p><strong>Despliegue y Entornos:</strong> Ubuntu, Servidores Apache/Nginx, Configuración y Gestión de Servidores</p>
          <TecnologiasGrid mostrar={stack} />

          <h4>Herramientas de Diseño:</h4>
          <p><strong>Figma:</strong> Creación de mockups y diseño de interfaz de usuario.</p>
          <p><strong>Photoshop:</strong> Edición de imágenes, creación de elementos gráficos, diseño de interfaces visuales.</p>
          <p><strong>Premiere:</strong> Edición y montaje de videos, creación de contenido audiovisual para interfaces y presentaciones.</p>
          <TecnologiasGrid mostrar={herramientas} />
          <h4>Uso de IA para Apoyo en el Desarrollo:</h4>
          <p><strong>ChatGPT:</strong> Asistencia en la resolución de problemas de programación, generación de documentación, sugerencias de optimización de código y mejora de la productividad en tareas de desarrollo.</p>
          <p><strong>Aplicación de Modelos de IA:</strong> Generación de ideas, corrección de errores comunes, y agilización de procesos de investigación técnica.</p>
          <TecnologiasGrid mostrar={ai} />

        </div>

      </Section>

      <Section className="section formacion">
        <div className="box-data">
          <h1>Formación académica</h1>
          <h4>Grado Superior en Desarrollo de Aplicaciones Multiplataforma (en ello)</h4>
          <p><a href="https://fpdrioja.es/" target="_blank" rel="noopener noreferrer">Centro Integrado de Formación Profesional de La Rioja</a></p>
          <p className="localidad">Logroño</p>
          <hr />
          <h4>Grado Superior en Desarrollo de aplicaciones WEB</h4>
          <p><a href="https://fpdrioja.es/" target="_blank" rel="noopener noreferrer">Centro Integrado de Formación Profesional de La Rioja</a></p>
          <p className="localidad">Logroño</p>
          <hr />
          <h4>Certificado de profesionalidad: IFCT0109 - Seguridad informática</h4>
          <p><a href="https://www.adrformacion.com/" target="_blank" rel="noopener noreferrer">ADR Formación</a></p>
          <p className="localidad">Logroño</p>
          <hr />
          <h4>Diplomatura de Dirección Cinematográfica y Realización de TV</h4>
          <p><a href="https://taiarts.com" target="_blank" rel="noopener noreferrer">Escuela Superior de Artes y Espectáculos TAI</a></p>
          <p className="localidad">Madrid</p>
          <hr />
          <h4>Grado Superior en Producción por Mecanizado</h4>
          <p><a href="https://www.mondragon.edu" target="_blank" rel="noopener noreferrer">Universidad de Mondragón</a></p>
          <p className="localidad">Mondragón</p>
        </div>


      </Section>

      <Section className="section profesional">
        <div className="box-data">
          <h1>Trayectoria Profesional</h1>
          <h4>Desarrollador Web independiente</h4>
          <p>Desde 2024 desarrollo proyectos web de forma independiente para empresas locales en La Rioja, aportando soluciones personalizadas y funcionales según sus necesidades.</p>
          <p>Además, colaboro con otros desarrolladores en proyectos de mediana y gran envergadura, integrando tecnologías complementarias cuando el alcance lo requiere.</p>
          <p className="localidad">La Rioja</p>
          <hr />
          {/* <h4>Desarrollador Web</h4>
          <p><a href="https://coloralavida.es" target="_blank" rel="noopener noreferrer">Asociación: Color a la Vida</a></p>
          <p>Actualización de la página de la asociación. Administrador.</p>
          <p>Logroño</p> */}
          {/* <hr />
          <h4>Prácticas de fin de carrera en desarrollo Web</h4>
          <p><a href="https://brandcode.es" target="_blank" rel="noopener noreferrer">BrandCode SL</a></p>
          <p>Logroño</p> */}
          <hr />
          <h4>Editor de video y operador de cámara</h4>
          <p>He trabajado en el sector audiovisual, como operador de cámara y editor de vídeo para productoras y televisiones.</p>
          <p>Esta trayectoria me ha permitido desarrollar un perfil versátil, con una base técnica sólida, sensibilidad visual y capacidad de trabajo en entornos exigentes. </p>
          <ul>
            <li>Realización de reportajes, spots publicitarios y cobertura de eventos (sociales, institucionales y culturales).</li>
            <li>Grabación y edición de vídeo para televisión y redes sociales.</li>
            <li>Colaboración con equipos creativos y técnicos en el desarrollo de contenidos visuales.</li>
            <li>Trabajo en entornos dinámicos, bajo presión y con atención al detalle técnico y estético.</li>
          </ul>
          <p className="localidad">País Vasco - Madrid - Cataluña - La Rioja - Perú - Santo Tomé y Príncipe</p>
          {/* <a className="saber" onClick={() => setPagina("saber")}>Saber más</a> */}
          <hr />
          <h4>Mecánico industrial</h4>
          <p>Durante mi trayectoria profesional inicial trabajé en el sector industrial del metal, donde he desarrollado competencias técnicas clave como la interpretación de planos,
            uso de software técnico, control de procesos productivos y precisión en la ejecución desarrollando labores como:</p>
          <ul>
            <li>Lectura e interpretación de planos técnicos para la fabricación de piezas metálicas.</li>
            <li>Manejo de maquinaria de control numérico (CNC) y herramientas de precisión.</li>
            <li>Supervisión de procesos productivos con enfoque en calidad y mejora continua.</li>
            <li>Trabajo en equipo en entornos industriales bajo altos estándares técnicos.</li>
          </ul>
          <p className="localidad">País Vasco - La Rioja</p>
        </div>

      </Section>

      <Section className="section transferencia">
        <div className="box-data">
          <h1>Transferencia a IT</h1>
          <p>La gestión de proyectos audiovisuales y el trabajo con herramientas tecnológicas me han permitido desarrollar una mentalidad analítica y enfocada en la optimización de procesos, habilidades que son esenciales en el desarrollo de software y la programación.</p>
          <p>Mi experiencia en edición y manejo de software me ha brindado una gran capacidad para trabajar con herramientas tecnológicas y me ha enseñado cómo aplicar la creatividad a problemas técnicos, algo que valoro enormemente al desarrollar aplicaciones y soluciones tecnológicas.</p>
          <p>El trabajo con contenidos interactivos y herramientas de diseño (como Figma) me ha preparado para una mejor comprensión de la experiencia de usuario (UX) y la interacción con plataformas tecnológicas, una habilidad valiosa para el diseño de interfaces y desarrollo web.</p>
        </div>

      </Section>

      <Section className="section habilidades">
        <div className="box-data">
          <h1>Habilidades Transferibles a IT</h1>
          <p><strong>Creatividad:</strong> Habilidad para crear soluciones visuales efectivas, algo que se refleja en el diseño de interfaces de usuario y la creación de experiencias interactivas en el desarrollo de aplicaciones.</p>
          <p><strong>Manejo de Herramientas Digitales:</strong> Experiencia con software de edición avanzada y herramientas tecnológicas, lo que facilita el aprendizaje y la adaptación a herramientas en desarrollo de software y tecnologías emergentes.</p>
          <p><strong>Resolución de Problemas Técnicos:</strong> Resolución de desafíos técnicos bajo presión, un enfoque que también utilizo para resolver problemas en el desarrollo de software y optimización de procesos.</p>
          <p><strong>Gestión de Proyectos:</strong> Experiencia en la gestión de tiempos y recursos para cumplir plazos en proyectos audiovisuales, lo cual se traduce en una gestión eficaz de proyectos de desarrollo tecnológico.</p>
        </div>

      </Section>

      <Section className="section contacto">
        <div className="box-data">
          <h1>¿Hablamos?</h1>
        </div>
        <a className="button-big" onClick={() => setPagina("contacto")}>Contáctame</a>



      </Section>


    </div>
  );
}
